export const GRADIENT_REQUIRED_STOP_PROPERTIES = ['color', 'position'] as const;
